import type { GeneratorComparisonSummary } from "encamp-shared/src/facility/generatorComparisonSummary";

import { Typography } from "@mui/material";
import { wasteGeneratorStatusToFullLabel } from "encamp-shared/src/waste";

export type ComparisonForDisplay = Pick<GeneratorComparisonSummary, "axis" | "direction"> &
  Partial<Omit<GeneratorComparisonSummary, "axis" | "direction">>;

export function PriorityComparisonSummary({
  comparison,
}: {
  comparison?: ComparisonForDisplay | null;
}) {
  if (!comparison) return null;
  return (
    <Typography variant="body2">
      Priority: {comparison.axis === "STATE" ? "State" : "Federal"}{" "}
      {wasteGeneratorStatusToFullLabel(comparison.reportedStatus ?? "")} →{" "}
      {wasteGeneratorStatusToFullLabel(comparison.calculatedStatus ?? "")}
      {" · "}
      {comparisonDuration(comparison)}
      {comparison.earliestMismatch && comparison.latestMismatch && (
        <>
          {" "}
          · {comparison.earliestMismatch} – {comparison.latestMismatch}
        </>
      )}
    </Typography>
  );
}

function comparisonDuration(comparison: ComparisonForDisplay): string {
  if (
    comparison.sustainedMonths == null ||
    comparison.mismatchMonths == null ||
    comparison.spanMonths == null
  ) {
    return "Duration unavailable for this comparison";
  }
  return `${comparison.sustainedMonths} consecutive months · ${comparison.mismatchMonths} mismatch months · ${comparison.spanMonths} month span`;
}
